export default "__VITE_ASSET__Cp74WuoQ__"